import { render } from "./GeoUpload.vue?vue&type=template&id=64572ead"
import script from "./GeoUpload.vue?vue&type=script&lang=js"
export * from "./GeoUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__